import React, { Fragment, useState, useEffect, useContext } from 'react';
import propTypes from 'prop-types';
import Images from 'assets/images/imageData';
import Layout from 'components/sales/layout/layout';
import PostCampForm from 'components/brandActivation/postCampForm';
import localization from 'assets/localization/localization';
import ModalPop from 'components/sales/modal/modal';
import { Button } from 'react-bootstrap';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';

const PostCamp = ({ addPostCamp, match, history }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [campId, setCampId] = useState(null);
  const [siteId, setSiteId] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const [userDetails, setUserDetails] = useState([]);
  const [isFiled, setIsFiled] = useState(false);
  const { baseUrl } = useContext(BaseUrl);

  useEffect(() => {
    setCampId(match.params.id);
    setSiteId(match.params.siteId);
  }, [match]);

  const handleIsSuccess = () => {
    setIsSuccess(false);
    history.goBack();
  };

  const handleSubmit = async () => {
    if (userDetails !== null && userDetails.length > 0) {
      const data = {
        camp_id: campId,
        site_id: siteId,
        user_details: userDetails,
      };
      setIsFiled(true);
      setIsLoading(true);
      await addPostCamp(data);
      setIsLoading(false);
      setIsSuccess(true);
    } else {
      setIsFiled(false);
    }
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={handleSubmit}
          className="btn btn-primary"
          disabled={userDetails === null}
        >
          {localization.submitDtl}
          <img src={Images?.ArrowRight} alt="" />
        </Button>
      </Fragment>
    );
  };

  const successIconBox = () => {
    return (
      <div className="text-center">
        <div className="success">
          <img src={Images?.tick} alt="" />
        </div>
        <h5>{localization.addPostCampSuccess}</h5>
        <Button onClick={handleIsSuccess} className="btn btn-primary">
          {localization.continue} <img src={Images?.ArrowRight} alt="" />
        </Button>
      </div>
    );
  };

  return (
    <Fragment>
      <Layout
        title={localization.postCamp}
        isLoading={isLoading}
        isGoback
        Buttons={headerBtns}
        linkUrl={`${baseUrl}/brand-activation/conduct-camp/camp/${match.params.siteId}`}
      >
        <PostCampForm
          handleValue={(val) => setUserDetails(val)}
          isFiled={isFiled}
        />
      </Layout>
      <ModalPop
        title={localization.success}
        show={isSuccess}
        handleModalHide={handleIsSuccess}
      >
        {successIconBox()}
      </ModalPop>
    </Fragment>
  );
};

PostCamp.propTypes = {
  postPostCamp: propTypes.func,
};

export default PostCamp;
